// Request HPS list: GET /hps/getall-list-hps query builder, status metadata
// and the Excel/CSV export. Fetch and download helpers are shared with the
// Plan & Procurement list.

import { api } from '../../../config';
import { downloadSheet } from '../../Procurement/utils/procurementList';
import { getListProductTypeLabel } from '../../../shared/offer-domain/constants';

export const REQUEST_HPS_PROCUREMENT_TYPE_MAP = {
  '': '-',
  PelelanganKhusus: 'Pelelangan Khusus',
  PemilihanLangsung: 'Pemilihan Langsung',
  TunjukLangsung: 'Tunjuk Langsung',
};

// `value` is the StatusHps2 query value and the statusHps a row carries.
export const REQUEST_HPS_STATUSES = [
  {
    value: 'Requested',
    label: 'Request',
    icon: 'ri-mail-send-line',
    tone: 'info',
    stat: 'open',
  },
  {
    value: 'Submitted',
    label: 'Submitted',
    icon: 'ri-checkbox-circle-line',
    tone: 'success',
    stat: 'done',
  },
];

// Anything but "Requested" has always been shown as Submitted.
export const isRequested = row => row?.statusHps === 'Requested';

export const DEFAULT_SORT_FIELD = 'procurementNumber';

export const buildRequestHpsListUrl = ({
  currentPage,
  rowsPerPage,
  search,
  status,
  sortField,
  sortDirection,
}) => {
  const params = new URLSearchParams();
  params.set('PageNumber', String(currentPage));
  params.set('PageSize', String(rowsPerPage));
  params.set('isProcurementCompleted', 'true');
  if (search?.trim()) params.set('Search', search.trim());
  if (status) params.set('StatusHps2', status);
  if (sortField) {
    params.set('SortBy', sortField);
    params.set('IsDescending', sortDirection === 'desc' ? 'true' : 'false');
  }
  return `${api.API_URL}/hps/getall-list-hps?${params.toString()}`;
};

const toExportRow = row => ({
  'ID Proc': row.procurementNumber || '',
  Title: row.titleProcurement || '',
  'Proc Type':
    REQUEST_HPS_PROCUREMENT_TYPE_MAP[row.procurementType] ||
    row.procurementType ||
    '',
  Product: row.productType?.name || '',
  'Product Type':
    getListProductTypeLabel(row, row.productType?.description) || '',
  Description: row.description || '',
  Status: isRequested(row) ? 'Request' : 'Submitted',
});

export const exportRequestHpsList = (rows, opts) =>
  downloadSheet(rows.map(toExportRow), { ...opts, prefix: 'RequestHps' });
